import axios, { AxiosRequestConfig } from 'axios';
import { User } from 'oidc-client-ts';

// Global variable to store the current user
let currentUser: User | null = null;

// Function to set the current user (called from OIDC context)
export function setCurrentUser(user: User | null) {
    currentUser = user;
}

// Function to get the current user
export function getCurrentUser(): User | null {
    return currentUser;
}

// Function to get the access token
export function getAccessToken(): string | null {
    return currentUser?.access_token || null;
}

// Function to initialize user from OIDC context (call this on app startup)
export function initializeUserFromOidcContext(auth: any) {
    if (auth.isAuthenticated && auth.user && !currentUser) {
        currentUser = auth.user;
    }
}

// Create axios instance with interceptors
const apiClient = axios.create({
    baseURL: '/api',
    timeout: 10000,
});

// Request interceptor to add JWT token to all requests
apiClient.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        const token = getAccessToken();
        if (token) {
            config.headers = config.headers || {};
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle token expiration
apiClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // If we get a 401, the token might be expired
        if (error.response?.status === 401) {
            // Clear the current user to trigger re-authentication
            setCurrentUser(null);
            // Redirect to login or trigger OIDC re-authentication
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default apiClient;
